import logger from "./services/logger"

export function getPurOrg(org={})
{
    let purOrg={...org}
    delete purOrg.caisses
    delete purOrg.events
    delete purOrg.horaires
    delete purOrg.pages
    delete purOrg.services
    delete purOrg.forms
    delete purOrg.web_menu
    delete purOrg.mainPage

    logger.debug({ purOrg }, "purOrg")
    return purOrg
}


export function uuidv4() {
    return "10000000-1000-4000-8000-100000000000".replace(/[018]/g, c =>
        (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
    );
}